import React, { useEffect, useState } from "react";
import {
  Text,
  Stack,
  Flex,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody,
  Input,
  Button,
  Textarea,
  Select,
  Tabs,
  TabList,
  Tab,
  Box,
  Badge,
  useDisclosure,
  Tooltip,
} from "@chakra-ui/react";
import BrandButton from "../brandButton/BrandButton";
import { useMutation, mutateFunction } from "../../libs/apis";
import { CustomToast } from "../toast/CustomToast";
import { AiOutlineFileAdd } from "react-icons/ai";
import { useData } from "../../data";
import { ExternalLinkIcon } from "@chakra-ui/icons";
import dayjs from "dayjs";
import { FaRocket } from "react-icons/fa";
import PitchRequestModal from "../modal/PitchRequestModal";
import { useSelector } from "react-redux";

export default function PitchCard({ isOpen, onClose, company }) {

  const [pitchRequests, setPitchRequests] = useState([]);
  const userInfo = useSelector((state) => state?.user?.userInfo);
  const accountType = useSelector(
    (state) => state?.user?.userInfo?.userTypeTitle,
  );
  const loggedInUserType = userInfo?.userTypeTitle || '';
  const companyDetails = useSelector((state) => state?.company?.companyInfo);
  const expertDetails = useSelector((state) => state?.expert?.expertInfo);
  const accountInformationStatus =
    loggedInUserType === 'admin' || loggedInUserType === 'sub_admin'
      ? loggedInUserType
      : loggedInUserType === 'expert'
        ? expertDetails?.status
        : companyDetails?.status;
  const { addToast } = CustomToast();

  const {
    isOpen: requestPitchModalIsOpen,
    onOpen: onOpenRequestPitchModal,
    onClose: onCloseRequestPitchModal,
  } = useDisclosure();

  const statusColors = {
    pending: "yellow",
    shortlisted: "blue",
    invited: "green",
    declined: "red",
  };
  const {
    data: _pitchRequests,
    isLoading: isLoadingPitchRequests,
    refetch: refetchPitchRequests,
  } = useData(`pitch-requests`);

  const openRequestPitchModal = () => {
    if(accountInformationStatus == "draft"){
      addToast("Please complete your profile and company details", "warning")
    }else{
      onOpenRequestPitchModal()
    }
  }

  useEffect(() => {
    setPitchRequests(_pitchRequests?.data || [])
  }, [_pitchRequests])

  return (
              <Flex
                direction="row"
                gap="16px"
                className="w-full flex-wrap"
              >
                {pitchRequests?.length > 0 ? pitchRequests.map((request) => (
                  <Box
                    key={request.id}
                    className="rounded-2xl border border-gray-200 min-w-lg shadow-md flex flex-col justify-between hover:shadow-lg transition-all bg-white p-5"
                  >
                    <Box className="min-w-xl">
                        {/* Header */}
                    <Flex justify="space-between" align="center" className="mb-3">
                      <Text className="font-semibold text-lg text-gray-800">
                        {request.company?.title || "Unnamed Company"}
                      </Text>
                      <Badge
                        colorScheme={statusColors[request.status] || "gray"}
                        className="px-2 py-1 rounded-md text-sm capitalize"
                      >
                        {request.status}
                      </Badge>
                    </Flex>

                    {/* Body */}
                    <Flex direction="column" className="space-y-2 text-sm text-gray-700">
                      {/* Event */}
                      <Flex justify="space-between">
                        <Text className="font-medium text-gray-600">Event:</Text>
                        <Text className="text-gray-700">
                          {request.event?.name || <span className="text-gray-400">None</span>}
                        </Text>
                      </Flex>

                      {/* Deck */}
                      {request.deck_url && (
                        <Flex justify="space-between" align="center">
                          <Text className="font-medium text-gray-600">Deck:</Text>
                          <Text
                            color="brand.primary"
                            className="flex items-center text-blue-600 hover:underline"
                          >
                            View Deck <a href={request.deck_url} target="_blank" ><ExternalLinkIcon ml={1} /></a>
                          </Text>
                        </Flex>
                      )}

                      {/* Notes */}
                      {request.notes && (
                        <Box className="flex flex-wrap gap-3">
                          <Text className="font-medium text-gray-600 mb-1">Notes:</Text>
                          <Text className="text-gray-700">
                            {request.notes.length > 100
                              ? request.notes.slice(0, 100) + "..."
                              : request.notes}
                          </Text>
                        </Box>
                      )}

                      
                    </Flex>
                    </Box>
                    {/* Footer / Timestamps */}
                    <Flex justify="space-between" className="pt-2 mt-2 border-t border-gray-100 text-xs text-gray-500">
                        <Text>Submitted</Text>
                        <Text>{dayjs(request.createdAt).format("MMM D, YYYY")}</Text>
                      </Flex>
                  </Box>
                )) : (

                    <Box
                    className="rounded-2xl cursor-pointer border border-gray-200 shadow-md hover:shadow-lg transition-all bg-gradient-to-br from-blue-50 via-white to-blue-100 p-8 flex flex-col items-center justify-center text-center"
                    onClick={openRequestPitchModal}
                  >
                    
                    <Flex
                      className="rounded-full bg-blue-100 p-2 flex items-center justify-center mb-4"
                    >
                      <FaRocket className="text-blue-500 text-2xl" />
                    </Flex>
                    <Text className="font-semibold text-gray-700 text-base mb-2">
                      You haven’t submitted any pitch requests yet
                    </Text>

                    <Tooltip
                        label="Only founders with a completed profile and uploaded deck will be considered"
                        placement="top"
                    >
                    <Text className="text-gray-500 text-sm mb-6 max-w-sm">
                      Ready to share your company’s story? Click Submit a pitch request to get
                      invited to upcoming events and connect with investors.
                    </Text>
                    </Tooltip>
                  </Box>
                )}

      <PitchRequestModal
        isOpen={requestPitchModalIsOpen}
        onClose={onCloseRequestPitchModal}
        company={companyDetails}
      />
    </Flex>

    );
}
